/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MicrophoneArrowRightIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB1ElEQVR4nM2Uy0ocURCGm2ShJEsVhJBlEBIvi2TvSmicqYuBY9WI4j478wKzDkIWIu58gERD1lGYQIaQbL0/gFsviOAFlJbq7pGZoWe6e+hACg50n66q/9RXp8vzCjIgWQfWWrlcGSwqZ4sB609kDZBlJ7dI6X3lFZJ+Q5YLZNlP8vGdGwKWXRMB0sNp54YzJweSk+h0GiDqUiffnkSAZeMxOWvAvDAQ7evv5v2kBSx/UwWQ5aw5qMEXSeppAkj6J70C0ruWoBRESLqXq9nQJgCkt8jysYEqiX+umwTtFbQsOatWq09iZFuZkofNI6lnE9DAOfc0FGD5hKQ/Uk8OpJdRM8vPIkE573hLSC8zYWir4CBu5rv4ZJtdEH03H8M0NTX/PJMAsqzEd/izvUc/mp4m8Ud0I1GMLodVU+VDugC610ByjyTXpZnZ0VCk5F4gyZd4VFwg6VcieRl+m5mdQNYbiwHQ8WyYSFYjxnLcEEn0Ax03n/inWvOy2uTiYj+wbseNvDJczHNvbd+WPduenTzCqTXf9/u8PGYB1o8QV8dbZCh1zUS9Xg1A34SNfxwBhkOODCPR3JhXpGEsUGjSfy4A3eZ+00jp2bDL3AfWX4VU8V/bA64JdQorw4AAAAAAAElFTkSuQmCC)
 */
export const MicrophoneArrowRightIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="m19.7.3 4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4L20.58 6H15a1 1 0 1 1 0-2h5.59l-2.3-2.3A1 1 0 0 1 19.71.3Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M12.62 2.05c.41.06.46.61.17.92A3 3 0 0 0 15 8h.51c.28 0 .5.22.5.5V10a4 4 0 1 1-8 0V6a4 4 0 0 1 4.62-3.95Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M17.56 12.27a.63.63 0 0 1 .73-.35c.21.05.43.08.65.08.38 0 .72.35.6.7A8 8 0 0 1 13 17.94V20h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-2.06A8 8 0 0 1 4 10a1 1 0 0 1 2 0 6 6 0 0 0 11.56 2.27Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
